import { matchPath } from "react-router-dom";

export function planGroupScope(groupId) {
	return `plan:group:${groupId}`;
}

export function employeeScope(employeeId) {
	return `employee:${employeeId}`;
}

export function documentsScope(categoryId) {
	return `documents:${categoryId}`;
}

export function pathnameScope(pathname) {
	return `route:${pathname}`;
}

export function resolveScopeFromRoute(location) {
	const pathname = location?.pathname || "";

	const planMatch = matchPath(pathname, {
		path: "/plans/:group/:start@:end",
		exact: true,
	});
	if (planMatch?.params?.group) {
		return planGroupScope(planMatch.params.group);
	}

	const employeeMatch = matchPath(pathname, {
		path: "/employees/:id",
		exact: true,
	});
	if (employeeMatch?.params?.id) {
		return employeeScope(employeeMatch.params.id);
	}

	const groupMatch = matchPath(pathname, {
		path: "/groups/:id",
		exact: true,
	});
	if (groupMatch?.params?.id) {
		return `group:${groupMatch.params.id}`;
	}

	const documentsMatch = matchPath(pathname, {
		path: "/documents/:category",
		exact: true,
	});
	if (documentsMatch?.params?.category) {
		return documentsScope(documentsMatch.params.category);
	}

	return pathnameScope(pathname);
}
